// @givmo/board — the hint beside a seat's first term (CBG-UX5-HINT; design stop design-268's §9 and
// §10, frames a1 and a2).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// All of them. Jonathan approved the screens for building with every new word a draft (D-CBG-35,
// 2026-10-22 23:09 PDT, "looks good"), and the words, every row as recommended, in the wayfinding copy
// round (2026-10-24 11:11 PDT). Each line names the frame that draws it. CBG-UX-COPY2 (D-CBG-42,
// 2026-10-24 19:08 PDT, A3) reworded the first line, so a director elected later finds it too.
//
// ⚠ Where the date usually comes from, never what it must be: a term's dates are the organization's
// own account (backend `board-terms.md` §1), and a blank one is recorded as not recorded, never
// guessed. No line offers a start "at the board's founding" without a date (D-CBG-35 (4)).

export const termHintWords = {
  // Drawn a1 and a2: the one quiet line under the term's dates.
  line: 'Not sure when their term started? It’s usually in the record that named or elected them.',
  // Drawn a1 and a2: the disclosure's button.
  where: 'Where to find it',
  // Drawn a2: the lines it opens, in order. Each says where to look, and "may" where it names a date
  // (4.3).
  lines: [
    'Look in your founding papers: the written consent that named your first directors, or the minutes of the board’s first meeting.',
    'If your articles of incorporation name the first directors, it may be the day the articles were filed.',
    'For someone elected later, look at the meeting or written consent that elected them.',
  ],
  // Drawn a2: the last line, on "Add a member" only. "Record a term" is on their page already, and
  // records at least one date (the orchestrator's mark, 2026-10-23).
  later:
    'Not at hand? Leave it blank. You can add it later on their page, with the record it came from.',
} as const;
